'use client'
import SearchBar from './searchBar'

import FiltersButton from './filtersButton'
import { usePathname } from 'next/navigation'

const Search = () => {
  const url = usePathname()
  const pagesHideFilter = [
    '/advancedSearch',
    '/students',
    '/professors',
    '/professionals',
    '/medical',
    '/Canada',
  ]
  return (
    <div className="bg-[#E1E1E1] h-[61px] justify-center items-center py-[12px] px-[20px] flex flex-col max-[768px]:h-[63px] max-[768px]:py-[15px] max-[768px]:px-[20px] max-[768px]:mt-[56px] max-[1200px]:mt-[56px]">
      <div className="flex justify-center max-[768px]:w-full flex-col">
        <div className="flex flex-row justify-center">
          <SearchBar />
          <div className={`${pagesHideFilter.includes(url) ? 'hidden' : 'block'}`}>
            <FiltersButton />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Search
